import { LanguageProvider } from '../contexts/LanguageContext';
import { Navbar } from './landing/Navbar';
import { HeroSection } from './landing/HeroSection';
import { FeaturesSection } from './landing/FeaturesSection';
import { IndustriesSection } from './landing/IndustriesSection';
import { BenefitsSection } from './landing/BenefitsSection';
import { PlatformSection } from './landing/PlatformSection';
import { BrandMapSection } from './landing/BrandMapSection';
import { MethodSection } from './landing/MethodSection';
import { ProofSection } from './landing/ProofSection';
import { CreatorSection } from './landing/CreatorSection';
import { PricingSection } from './landing/PricingSection';
import { ContactSection } from './landing/ContactSection';
import { Footer } from './landing/Footer';

// Landing page composition.
// Wrapped in LanguageProvider — every public landing section can toggle
// between Dutch and English via the navbar pill. Authenticated app
// pages are not affected.
export const LandingPage = () => (
  <LanguageProvider>
    <div className="lp-scope min-h-screen bg-[#0a0a0a]">
      {/* Fixed Blurred Logo Background */}
      <div className="fixed inset-0 z-0 flex items-center justify-center pointer-events-none overflow-hidden">
        <img
          src="/brand/kanriva-mark.png"
          alt=""
          className="w-[700px] h-[700px] object-contain"
          style={{ opacity: 0.06, filter: 'blur(40px)' }}
        />
      </div>
      <Navbar />
      <HeroSection />
      <BrandMapSection />
      <MethodSection />
      <PlatformSection only="kaizen" />
      <ProofSection />
      <PlatformSection only="flowcrew" />
      <BenefitsSection />
      <IndustriesSection />
      <CreatorSection />
      <FeaturesSection />
      <PricingSection />
      <ContactSection />
      <Footer />
    </div>
  </LanguageProvider>
);

export default LandingPage;
